import { Pagination } from 'antd';
import { RefreshCw } from 'feather-icons-react/build/IconComponents';
import React, { useEffect, useState } from 'react'
import { getSalesReport } from '../../services/ReportApiService';
import Table from '../../core/pagination/datatable'
import { Link } from 'react-router-dom';
function CustomerCredit() {
  const [customerCreditData, setCustomerCreditData] = useState([]);
    useEffect(() => {
      handleSaleReportList()
    }, [])
    
    const handleSaleReportList = async ()  =>{
      try {
        const response = await getSalesReport();
        setCustomerCreditData(response)
        console.log(response);
    } catch (error) {
        console.log(error);
    }
      }
   
   
    const columns = [
      {
        title: "Date",
        dataIndex: "date",
        sorter: (a, b) => a.Name?.length - b.Name?.length,
      },
      {
        title: "BillNo",
        dataIndex: "billNo",
        sorter: (a, b) => a.Percentage?.length - b.Percentage?.length,
      },
      {
        title: "RefNo",
        dataIndex: "refNo",
        sorter: (a, b) => a.Percentage?.length - b.Percentage?.length,
      },
     
      {
      title: "Customer",
      dataIndex: "customer",
      sorter: (a, b) => a.Percentage?.length - b.Percentage?.length,
      },
      {
        title: "Amount",
        dataIndex: "amount",
        sorter: (a, b) => a.Percentage?.length - b.Percentage?.length,
        },
      
  
    ];
  
   
  return (
    <div>
        <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Customer Credit</h4>
              </div>
            </div>
            <ul className="table-top-head">
              
             
             
              
            </ul>
            <div className="d-flex purchase-pg-btn">
              <div className="page-btn">
               
              </div>
              <div className="page-btn import">
                <Link
                  to="#"
                  className="btn btn-added color"
                  data-bs-toggle="modal"
                  data-bs-target="#view-notes"
                >
                  <RefreshCw className="me-2" />
                  Refresh
                </Link>
              </div>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
             
              {/* /Filter */}
              
              {/* /Filter */}
              <div className="table-responsive product-list">
                <Table columns={columns} dataSource={customerCreditData} />
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>
      <Pagination />
    </div>
  )
}

export default CustomerCredit